import React from "react";

import { Button, Col, Modal, Row } from "react-bootstrap";

export const AlertModal = ({
    modalInfo,
    setModalInfo,
    api = null,
    size = "sm",
    confirmText = "Confirm",
    cancelText = "Cancel",
}) => {
    const closeModal = () => {
        setModalInfo({
            ...modalInfo,
            open: false,
        });
    };

    const callApi = () => {
        api();
        closeModal();
    };

    return (
        <Modal
            show={modalInfo.open}
            onHide={() => closeModal()}
            size={size}
            centered
        >
            <Modal.Body className="text-center m-2">
                <p className="mb-0">{modalInfo.notifMsg}</p>
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col md={12} className="text-center">
                        <Button
                            className="me-2"
                            variant="primary"
                            type="submit"
                            onClick={() => callApi()}
                        >
                            {confirmText}
                        </Button>
                        <Button variant="link" onClick={() => closeModal()}>
                            {cancelText}
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};
